(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-bpg-frame"] && !Shopify.designMode) return;
  try {
    (()=>{const reduce=matchMedia('(prefers-reduced-motion: reduce)');let queued=false;const update=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;document.querySelectorAll('[data-cm-bpg-parallax]').forEach(media=>{if(reduce.matches){media.style.transform='none';return}const box=media.parentElement.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;const progress=(innerHeight/2-box.top-box.height/2)/(innerHeight/2+box.height/2);const travel=Math.max(-18,Math.min(18,progress*18));media.style.transform='translate3d(0,'+travel.toFixed(2)+'px,0)';})})};addEventListener('scroll',update,{passive:true});addEventListener('resize',update,{passive:true});addEventListener('pageshow',update);reduce.addEventListener('change',update);document.addEventListener('shopify:section:load',update);update()})();
  } catch(e) { console.error(e); }
})();

})();
